"use client";

// import { useMediaQuery } from "../../../helpers/useMediaQuery";
import { Header } from "../../Header/Header";

interface HeaderWithBreakpointProps {
  className?: string;
  localeString: string;
  dir: "ltr" | "rtl";
  /** Disable sticky header (e.g. on support-hub pages). Passed to rbcom-navigation. */
  stickyDisabled?: boolean;
}

export const CrhHeaderWithBreakpoint = ({
  className,
  localeString,
  dir,
  stickyDisabled,
}: HeaderWithBreakpointProps) => {
  // Use media query to determine theme based on viewport width
  // >= 1000px: light theme, < 1000px: dark theme
  // Default to desktop (light) so SSR/first paint show light; effect corrects to dark on mobile (avoids nav widget reading "dark" before our effect runs on desktop)
  // const isDesktop = useMediaQuery("(width >= 1000px)", {
  //   defaultValue: true,
  //   initializeWithValue: false,
  // });

  // const dynamicTheme = isDesktop ? "light" : "dark";

  return (
    <Header
      className={className}
      localeString={localeString}
      dir={dir}
      theme="light"
      stickyDisabled={stickyDisabled}
    />
  );
};
